// 篮球 联赛 顶部菜单

module.exports = {
  menuSeasonName: '中国男子职业篮球联赛',
  sportType: 'basketball',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '概述',
        //   key: 'summary',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'scheduleIndex_CBA',
          act: true,
        },
        {
          name: '球队排名',
          key: 'teamRank',
          routeName: 'teamRankIndex_CBA',
          act: false,
        },
        {
          name: '季后赛对阵',
          key: 'playoffsVsMap',
          routeName: 'playoffsVsMapIndex_CBA',
          act: false,
        },
        {
          name: '球队',
          key: 'team',
          routeName: 'teamIndex_CBA',
          act: false,
        },
        {
          name: '球员',
          key: 'player',
          routeName: 'playerIndex_CBA',
          act: false,
        },
        {
          name: '数据中心',
          key: 'record',
          routeName: 'recordDetailIndex_CBA',
          act: false,
          child: [
            {
              name: '数据概览',
              key: 'dataOverview',
              act: false,
              routeName: 'recordDetailDataOverview_CBA',
            },
            {
              name: '球队数据',
              key: 'teamData',
              act: false,
              routeName: 'recordDetailTeamData_CBA',
            },
            {
              name: '球员数据',
              key: 'playerData',
              act: false,
              routeName: 'recordDetailPlayerData_CBA',
            },
            {
              name: '阵容数据',
              key: 'lineupData',
              act: false,
              routeName: 'recordDetailLineupData_CBA',
            },
          ],
        },
        {
          name: '场馆',
          key: 'sportsHall',
          routeName: 'sportsHallIndex_CBA',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'programListIndex_CBA',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'broadcastListIndex_CBA',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'dataPackagListIndex_CBA',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
